<template>
  <div class="bbc-work" v-if="info">
    <div class="bbc-work-w">
      <div class="lp">
        <div class="cover-w">
          <img class="cover" :src="info.cover.b" alt="artist"/>
        </div>
        <p class="hint">{{ info.coverAlt }}</p>
      </div>
      <div class="rp">
        <p class="title">{{ info.name }}</p>
        <div class="row">
          <p class="vv artist">{{ info.artist }}</p>
        </div>
        <template v-if="info.exhibitions && info.exhibitions.length">
          <div class="row">
            <p class="vv">
              <a @click="goExhibitionInfo(exhibition)" v-for="(exhibition, index) in info.exhibitions"
                 :key="index">{{ exhibition.title }}</a>
            </p>
          </div>
        </template>
        <div class="row" v-if="info.year">
          <p class="vv">{{ info.year }}</p>
        </div>
        <div class="row" v-if="info.material">
          <p class="vv">{{ info.material }}</p>
        </div>
        <div class="row">
          <p class="vv">{{ info.size }}</p>
        </div>
        <div class="row" v-if="info.thanks">
          <p class="vv thanks">{{ info.thanks }}</p>
        </div>
        <p class="intro">
          {{ info.context }}
        </p>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "artworkInfo",
  components: {},
  props: {
    info: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {}
  },
  methods: {
    goExhibitionInfo(item) {
      item.goDetail();
      this.$emit('goExhibitionHandel');
    },
  }
};
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/artworkInfo.vue